<bricks-input
  appDigitsOnly
  [showResetOption]="true"
  [allowDot]="true"
  [allowComma]="false"
  [name]="name()"
  [label]="label()"
  [placeholder]="placeholder()"
  [width]="width()"
  [isRequired]="isRequired()"
  [formControl]="control()"
  (focusout)="handleValueChange()">
  <span text-suffix>{{ suffix() }}</span>
  @if (error()) {
    <bricks-error>{{ error() }}</bricks-error>
  }
</bricks-input>
